import React, { useEffect, useRef, useState } from 'react';
import { BrandModel } from '../../../models/brand';
import axios from '../../../lib/axios';
import { CREATE_BRAND, UPDATE_BRAND } from '../../../lib/endpoints/brand';

interface Props {
  selectedData: BrandModel;
  selectedValue: Function;
  onFetchData: Function;
  onClose: VoidFunction;
}

const useFormBrandController = ({ selectedData, selectedValue, onFetchData, onClose }: Props) => {
  // ------- variable -----------//
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);

  const nameEng = useRef<HTMLInputElement>(null!);
  const nameLao = useRef<HTMLInputElement>(null!);

  // ------- api manage -------- //

  const handleCreateBrand = async () => {
    try {
      setLoadingButton(true);
      const InputForm = {
        nameEn: nameEng.current.value,
        nameLa: nameLao.current.value,
      };
      await axios.post(CREATE_BRAND, InputForm);
      onFetchData();
      handleResetForm();
      onClose();
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingButton(false);
    }
  };

  const handleUpdateBrand = async () => {
    try {
      setLoadingButton(true);
      const InputForm = {
        nameEn: nameEng.current.value,
        nameLa: nameLao.current.value,
      };
      await axios.patch(UPDATE_BRAND + selectedData?.id, InputForm);
      onFetchData();
      handleResetForm();
      onClose();
    } catch (err) {
    } finally {
      setLoadingButton(false);
    }
  };

  // ------- function ----------//
  const handleOpenConfirmForm = (e: React.FormEvent) => {
    e.preventDefault();
    if (handleValidate()) {
      setOpenConfirm(true);
    }
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleValidate = () => {
    setErrorMessage('');
    return true;
  };

  const handleResetForm = () => {
    selectedValue(null);
    if (nameLao.current) nameLao.current.value = '';
    if (nameEng.current) nameEng.current.value = '';
  };

  const handleSubmit = () => {
    if (selectedData?.id) {
      handleUpdateBrand();
    } else {
      handleCreateBrand();
    }
  };

  // ------- useEffect --------//
  useEffect(() => {
    if (selectedData) {
      nameLao.current.value = selectedData?.nameLa;
      nameEng.current.value = selectedData?.nameEn;
    }
  }, [selectedData]);

  return {
    handleCloseConfirm,
    errorMessage,
    openConfirm,
    loadingButton,
    handleOpenConfirmForm,
    handleSubmit,
    handleResetForm,
    nameEng,
    nameLao,
  };
};
export default useFormBrandController;
